/* EU withdrawal form — two-step flow + received-timestamp capture.
   Step 1 (intention) → separate Step 2 (confirmation) → Shopify contact-form POST.
   The received timestamp is stamped at the moment of final submit, from the submission itself.
   Guarded so it binds once even if the section reloads in the theme editor. */
(function () {
  if (window.__tytWithdrawalInit) return;
  window.__tytWithdrawalInit = true;

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var root = document.querySelector('[data-tyt-wd]');
    if (!root) return;

    var form = root.querySelector('.tyt-wd-form');

    /* Success state: key off the card, NOT off "there is no form".
       The {% form %} tag now wraps the whole body (it has to — the success
       message can only be detected from inside the form's scope), so the form
       element is present on the success page too and the old !form test never
       fired. The card is the reliable signal; the !form fallback is kept for
       any render where the form genuinely is absent. */
    var success = root.querySelector('[data-wd-success]');
    if (success) {
      try { success.focus(); } catch (e) {}
      return;
    }
    if (!form) return;

    var step1 = form.querySelector('[data-wd-step="1"]');
    var step2 = form.querySelector('[data-wd-step="2"]');
    var nextBtn = form.querySelector('[data-wd-next]');
    var backBtn = form.querySelector('[data-wd-back]');
    var step2Heading = form.querySelector('[data-wd-step2-heading]');

    var checkoutEmail = form.querySelector('[data-wd-checkout-email]');
    var confirmEmail = form.querySelector('[data-wd-confirm-email]');
    var confirmEmailTouched = false;

    var required = Array.prototype.slice.call(
      step1.querySelectorAll('input[required], textarea[required]')
    );

    /* ── mirror checkout email → confirmation email until the user edits it ── */
    if (checkoutEmail && confirmEmail) {
      confirmEmail.addEventListener('input', function () { confirmEmailTouched = true; });
      checkoutEmail.addEventListener('input', function () {
        if (!confirmEmailTouched) confirmEmail.value = checkoutEmail.value;
      });
    }

    /* ── build the Step 2 review echo from Step 1 values ── */
    function fillReview() {
      var map = {};
      Array.prototype.slice.call(form.querySelectorAll('[data-wd-echo]')).forEach(function (el) {
        map[el.getAttribute('data-wd-echo')] = (el.value || '').trim();
      });
      Array.prototype.slice.call(form.querySelectorAll('[data-wd-review]')).forEach(function (el) {
        var key = el.getAttribute('data-wd-review');
        if (key in map) el.textContent = map[key];
      });
      var noteRow = form.querySelector('[data-wd-review-note]');
      if (noteRow) {
        if (map.note) { noteRow.hidden = false; }
        else { noteRow.hidden = true; }
      }
    }

    function focusFirstInvalid() {
      for (var i = 0; i < required.length; i++) {
        if (!required[i].checkValidity()) { required[i].reportValidity(); return false; }
      }
      return true;
    }

    function toConfirm() {
      if (!focusFirstInvalid()) return;
      fillReview();
      step1.hidden = true;
      step2.hidden = false;
      root.setAttribute('data-wd-stage', 'confirm');
      if (step2Heading) { try { step2Heading.focus(); } catch (e) {} }
      var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function toIntent() {
      step2.hidden = true;
      step1.hidden = false;
      root.setAttribute('data-wd-stage', 'intent');
      var first = step1.querySelector('input, textarea');
      if (first) { try { first.focus(); } catch (e) {} }
    }

    if (nextBtn) nextBtn.addEventListener('click', toConfirm);
    if (backBtn) backBtn.addEventListener('click', toIntent);

    /* ── stamp the received timestamp, from the submission, at final submit ── */
    function stampTimestamp() {
      var now = new Date();
      var tz = '';
      try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
      var local = now.toLocaleString(undefined, {
        weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      if (tz) local += ' (' + tz + ')';

      var localField = form.querySelector('[data-wd-ts-local]');
      var utcField = form.querySelector('[data-wd-ts-utc]');
      if (localField) localField.value = local;
      if (utcField) utcField.value = now.toISOString();
    }

    /* ── enforce the two-step gate ──
       Any submit (button OR Enter key) while still on Step 1 is intercepted and
       routed to the confirmation step. Only a submit from Step 2 goes through. */
    form.addEventListener('submit', function (e) {
      if (root.getAttribute('data-wd-stage') !== 'confirm') {
        e.preventDefault();
        toConfirm();
        return;
      }
      stampTimestamp();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
